import { createFileRoute } from "@tanstack/react-router"
import { ChatPage } from "./-components/ChatPage"

export const Route = createFileRoute("/app/com/chat/$chatId")({
  component: ChatPageWithId,
  beforeLoad: (_ctx) => ({
    getTitle: undefined,
  }),
})

function ChatPageWithId() {
  const { chatId } = Route.useParams()
  return <ChatPage chatId={parseInt(chatId)} />
}
